import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

import { UserService } from '@services/user.service';
import { PageService } from '@services/page.service';
import { HttpUtilService } from '@services/http-util.service';
import { environment } from '@env/environment';
import { NotificationsService } from '@services/notifications.service';
import { TranslationService } from '@services/translation.service';
import { CognitoDomainService } from "@services/cognito-domain.service";
import { tap } from "rxjs/operators";

@Component({
  selector: 'app-new-password-required',
  templateUrl: './new-password-required.component.html',
  styleUrls: ['./new-password-required.component.scss']
})
export class NewPasswordRequiredComponent implements OnInit {

  objectKeys = Object.keys;

  passwordStrength:number = 0 
  currentAttributes: any = {};
  requiredAttributes = [];

  newPhone = false;
  phoneItem = {
    label: 'Phone Number'
  };
  setPassword = false;
  policies = null;
  newPw = null;
  oldPw = null;
  updatedUserData = {};
  cognitoSsoUr$: any;
  hasSSOEnabled: unknown;

  constructor(
    private notitifactions:NotificationsService,
    private userService: UserService,
    private router: Router,
    private page: PageService,
    public location: Location,
    private http: HttpUtilService,
    private translationService:TranslationService,
    private cognitoDomainService: CognitoDomainService


  ) { }

  ngOnInit() {
    this.page.updateHideMenu(true);
    this.cognitoSsoUr$ = this.cognitoDomainService.getCognitoSsoUrl$().pipe(
      tap(({ cognitoSsoUrl }) => {
        this.hasSSOEnabled = !!cognitoSsoUrl;
        const userTmp = this.userService.getUserAttributes();        
        if (userTmp && userTmp.currentAttributes && userTmp.requiredAttributes) {
          this.requiredAttributes = userTmp.requiredAttributes;
          // avoid setting email if sso enabled, it should be set at this point regardless
          this.currentAttributes = !this.hasSSOEnabled? userTmp.currentAttributes: Object.keys(userTmp.currentAttributes).reduce((acc,key)=>{
            if(key!=='email'){
              acc[key]= userTmp.currentAttributes[key]
            }
            return acc
          },{})
          
        } else {
          // We're missing important fields to finish setting up pw, back to login it is
          this.router.navigate(['/login']);
        }
      })
    );

    this.userService.getPasswordPolicy().subscribe(
      (policies) => {
        this.policies = policies;
      }
    );


  }

  isAttributeRequired(attribute) {
    return this.requiredAttributes.includes(attribute);
  }

  stillRequiredAttributes() {
    for (let i = 0; i < this.requiredAttributes.length; i++) {
      const att = this.requiredAttributes[i];
      if (this.currentAttributes[att] == '' || this.currentAttributes[att] == null) {
        return true;
      }
    }
    return false;
  }

  phoneNumberChanged({value}) {
    this.newPhone = true;
    const phoneObj = value
    this.currentAttributes['phone_number'] = phoneObj?.e164Number||phoneObj?.value?.e164Number

    this.updatedUserData['phone_number'] = phoneObj;
  }

  attributeChanged(cognitoAttr) {
    const cogntioAttributesMap = {
      'given_name': 'first_name',
      'family_name': 'last_name',
      'email': 'email',
    };

    const ourDataKey = cogntioAttributesMap[cognitoAttr];
    this.updatedUserData[ourDataKey] = this.currentAttributes[cognitoAttr];
  }

  attibutesName(name) {
    const names = {
      'given_name': 'First Name',
      'first_name': 'First Name',
      'family_name': 'Last Name',
      'last_name': 'Last Name',
      'email': 'Email',
      'phone_number': 'Phone Number'
    };
    return names[name] || name;

  }

  submitNewPw() {
    const udpatedKeys = Object.keys(this.updatedUserData);
    // If the email hasn't changed, don't send it to cognito
    if (udpatedKeys.indexOf('email') < 0) {
      delete this.currentAttributes.email;
    }
    if (udpatedKeys.indexOf('phone_number') < 0) {
      delete this.currentAttributes.phone_number;
    }
    this.userService.completeNewPasswordChallenge(this.newPw, this.oldPw, { ...this.currentAttributes }).subscribe(
      () => {
        // Maybe update user data in db

        if (udpatedKeys.length > 0) {
          this.http.request('PUT', environment.apiRoot + '/users/self', { 'data': this.updatedUserData }, null, true).subscribe();
        }

        // Cool, looks like you're new pw is setup
        this.router.navigate(['/verify-phone-and-email']);
      },
      (err) => {

        const text = this.translationService.getTranslatedContent('error_validating_new_password','Error Validating New Password')

        this.notitifactions.popNotification('',text)
      }
    );
  }

}
